/**
 * GA4 Global Analytics — Adheseal Theme
 * ──────────────────────────────────────
 * Centralised GA4 event tracking for interactions that
 * the Shopify Google & YouTube app cannot capture.
 *
 * Currently tracks:
 *   - Phone call clicks (tel: links)
 *   - Email clicks (mailto: links)
 *
 * Loaded globally via theme.liquid.
 */
(function ga4Analytics() {
    'use strict';

    /* ── Idempotency ── */
    if (document.documentElement.dataset.ga4AnalyticsInit) return;
    document.documentElement.dataset.ga4AnalyticsInit = 'true';

    /* ── Fire a GTM data layer event or fall back to direct GA4 ── */
    function sendEvent(eventName, params) {
        var googleTagManager = window.google_tag_manager || {};
        var hasGtmContainer = Object.keys(googleTagManager).some(function (key) {
            return key.indexOf('GTM-') === 0;
        });

        if (hasGtmContainer || typeof window.gtag !== 'function') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: eventName }, params));
            return;
        }

        if (typeof window.gtag === 'function') {
            window.gtag('event', eventName, params);
        }
    }

    /* ── Resolve branch context from store pages (data-store-location) ── */
    function getStoreLocation(scope) {
        /* Prefer the closest branch context to the clicked link so
         * listing pages with multiple branches tag the right store. */
        if (scope && scope.closest) {
            var scopedEl = scope.closest('[data-store-location]');
            if (scopedEl) {
                var scopedLocation = scopedEl.getAttribute('data-store-location');
                if (scopedLocation) return scopedLocation;
            }
        }
        var el = document.querySelector('[data-store-location]');
        if (el) {
            var location = el.getAttribute('data-store-location');
            if (location) return location;
        }
        return '';
    }

    /* ── Build params with stable and display branch context when available ── */
    function withStoreLocation(params, scope) {
        var storeLocation = getStoreLocation(scope);
        var storeScope = scope && scope.closest ? scope.closest('[data-store-id]') : null;
        var storeIdElement = storeScope || document.querySelector('[data-store-id]');
        var storeId = storeIdElement ? storeIdElement.getAttribute('data-store-id') : '';

        if (storeLocation) {
            params.store_location = storeLocation;
        }
        if (storeId) {
            params.store_id = storeId;
        }
        return params;
    }

    function getClickLocation(link) {
        var explicitLocation = link.getAttribute('data-analytics-location');
        if (explicitLocation) return explicitLocation;
        if (link.closest('.contact-store')) return 'store_contact_details';
        if (link.closest('.spotlight-item')) return 'store_service_cta';
        if (link.closest('header')) return 'header';
        if (link.closest('footer')) return 'footer';
        return 'page_content';
    }

    /* ─────────────────────────────────────────────
     * Phone & Email Click Tracking
     * ─────────────────────────────────────────────
     * Uses event delegation on document so it captures
     * clicks on tel: and mailto: links anywhere on the
     * page, including dynamically injected content.
     */
    document.addEventListener('click', function (e) {
        /* Walk up the DOM to find the nearest <a> tag */
        var link = e.target.closest('a[href]');
        if (!link) return;

        var href = link.getAttribute('href') || '';

        /* ── Phone click ── */
        if (href.indexOf('tel:') === 0) {
            var phoneNumber = href.replace('tel:', '').split('?')[0].trim();
            var clickLocation = getClickLocation(link);
            sendEvent('click_phone', withStoreLocation({
                link_url: href,
                link_text: (link.textContent || '').trim().substring(0, 100),
                phone_number: phoneNumber,
                click_location: clickLocation,
                page_location: window.location.href,
                page_title: document.title
            }, link));

            /* Also fire generate_lead for Google Ads */
            sendEvent('generate_lead', withStoreLocation({
                currency: 'AUD',
                value: 0,
                form_type: 'phone_call',
                phone_number: phoneNumber,
                click_location: clickLocation,
                page_location: window.location.href
            }, link));
            return;
        }

        /* ── Email click ── */
        if (href.indexOf('mailto:') === 0) {
            var emailAddress = href.replace('mailto:', '').split('?')[0].trim();
            sendEvent('click_email', withStoreLocation({
                link_url: href,
                link_text: (link.textContent || '').trim().substring(0, 100),
                email_address: emailAddress,
                page_location: window.location.href,
                page_title: document.title
            }, link));

            /* Also fire generate_lead for Google Ads */
            sendEvent('generate_lead', withStoreLocation({
                currency: 'AUD',
                value: 0,
                form_type: 'email_click',
                page_location: window.location.href
            }, link));
            return;
        }
    });

    /* ─────────────────────────────────────────────
     * Klaviyo Form Tracking
     * ─────────────────────────────────────────────
     * Listens for the "klaviyoForms" custom event fired
     * by Klaviyo's JS snippet.
     */
    window.addEventListener("klaviyoForms", function (e) {
        var type = e.detail.type;
        var formId = e.detail.formId;
        var meta = e.detail.metaData || {};

        var commonParams = {
            form: 'Klaviyo form',
            form_id: formId,
            page_location: window.location.href,
            page_title: document.title
        };

        /* ── Event mapping ── */
        if (type === 'open' || type === 'embedOpen') {
            sendEvent('form_open', commonParams);
        }
        else if (type === 'submit') {
            sendEvent('form_submit', commonParams);

            /* Also fire generate_lead for Google Ads */
            sendEvent('generate_lead', {
                currency: 'AUD',
                value: 0,
                form_type: 'klaviyo_signup',
                form_id: formId,
                page_location: window.location.href
            });
        }
        else if (type === 'stepSubmit') {
            var stepParams = Object.assign({}, commonParams, {
                step_name: meta.$step_name
            });
            sendEvent('form_step_submit', stepParams);
        }
        else if (type === 'redirectedToUrl') {
            sendEvent('form_url_redirect', commonParams);
        }
        else if (type === 'close') {
            sendEvent('form_close', commonParams);
        }
    });
})();
